import { render, staticRenderFns } from "./EmptyOrder.vue?vue&type=template&id=4a0322fa&scoped=true&"
import script from "./EmptyOrder.vue?vue&type=script&setup=true&lang=ts&"
export * from "./EmptyOrder.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./EmptyOrder.vue?vue&type=style&index=0&id=4a0322fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0322fa",
  null
  
)

export default component.exports